import { render } from "./scenario-edits.vue?vue&type=template&id=b633d78e&ts=true"
import script from "./scenario-edits.vue?vue&type=script&lang=ts"
export * from "./scenario-edits.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__